/*
 * Filter Anything v1.5.0
 * https://github.com/80DAYS/Filter-Anything
 */
$(document).ready(function() {
    $('[data-filter]').each(function() {
        var $_filterElement = $(this);
        var $_filterItems = $_filterElement.find('.' + $_filterElement.data('filter-class'));

        var $_filterTextAll = $_filterElement.data('filter-all') || 'All';

        var $_filterAllLast = $_filterElement.data('filter-all-last') || false;
        
        var filterButtonClass = $_filterElement.data('filter-button-class') || 'filter-anything-button';
        var filterSelectedButtonClass = $_filterElement.data('filter-selected-button-class') || 'filter-anything-selected';

        // Step 1: assemble a full list of each
        var filterCategories = '';
        $_filterItems.each(function() {
            if ( (typeof $(this).data('filter-categories') !== 'undefined') && ($(this).data('filter-categories') !== '') ) {
                filterCategories += $(this).data('filter-categories') + '|';
            }
        });
        filterCategories = filterCategories.substring(0, filterCategories.length - 1); // remove trailing |
        filterCategories = filterCategories.split('|'); // make it an array
        filterCategories = unique(filterCategories); // remove duplicates
        if (filterCategories.length <= 1) return; // Just stop if there aren't enough filter categories

        // Step 2: create the filter buttons with an optional dropdown on mobile
        var hasfilterDropdown = false;
        var filterDropdown = '';
        var buttonClass = '';

        if (typeof $_filterElement.data('filter-controls-select-dropdown-mobile') !== 'undefined') {
            hasfilterDropdown = true;
            buttonClass = 'hide-for-small-only';
            
            filterDropdown = '<div class="filter-controls-dropdown show-for-small-only"><select autocomplete="off">';
            if (typeof $_filterElement.data('filter-controls-select-dropdown-mobile-filter-label') !== 'undefined') {
                filterDropdown += '<option value="all" disabled selected>Filter</option>';
            }
            filterDropdown += '<option value="all">' + $_filterTextAll + '</option>';
        }

        var filterAllButton = '<button class="' + filterButtonClass + ' all ' + (!$_filterAllLast ? filterSelectedButtonClass +' ' : '') + buttonClass + '">' + $_filterTextAll + '</button>';

        var filterButtons = '';

        if (!$_filterAllLast) {
            filterButtons += filterAllButton;
        }

        var firstFilterButtonActive = $_filterAllLast;

        for (var category in filterCategories) {
            filterButtons += '<button class="' + filterButtonClass + ' ' + (firstFilterButtonActive ? filterSelectedButtonClass + ' ' : '') + buttonClass + '" data-filter-category="' + filterCategories[category] + '">' + filterCategories[category] + '</button>';

            if (hasfilterDropdown) {
                filterDropdown += '<option value="' + filterCategories[category] + '">' + filterCategories[category] + '</option>';
            }

            firstFilterButtonActive = false;
        }

        if ($_filterAllLast) {
            filterButtons += filterAllButton;
        }

        $_filterElement.find('.' + $_filterElement.data('filter-controls')).append(filterButtons);

        if (hasfilterDropdown) {
            filterDropdown += '</select></div>';
            $_filterElement.find('.' + $_filterElement.data('filter-controls')).append(filterDropdown);
        }

        // Step 4: set up the button events
        var $_filterButtons = $_filterElement.find('.' + $_filterElement.data('filter-controls')).find('button');

        $_filterButtons.on('click', function() {
            $(this)
                .siblings()
                .removeClass(filterSelectedButtonClass);

            // Clear the "All" button
            if (!$(this).hasClass('all')) {
                $_filterButtons.filter('.' + filterSelectedButtonClass).removeClass(filterSelectedButtonClass);
                $(this).addClass(filterSelectedButtonClass);
                var filterCategory = $(this).data('filter-category');

                // Trigger event to allow other JS to interact with the filter change
                $_filterElement.trigger('filter-changed', filterCategory);
            } else {
                // All button has been clicked, so show all buttons and return
                $_filterButtons.removeClass(filterSelectedButtonClass);
                $_filterButtons.filter('.all').addClass(filterSelectedButtonClass);
                $_filterElement.find('.filter-controls-dropdown select').val('all');

                $_filterItems.fadeIn();

                // Trigger event to allow other JS to interact with the filter change
                $_filterElement.trigger('filter-changed', null);

                return;
            }

            // Only show the items that match the filter
            $_filterItems.each(function() {
                if (typeof $(this).data('filter-categories') !== 'undefined') {
                    if (
                        $(this)
                            .data('filter-categories')
                            .indexOf(filterCategory) > -1
                    ) {
                        $(this).fadeIn();
                    } else {
                        $(this).fadeOut();
                    }
                }
            });

            // Update the mobile dropdown
            if ($(window).innerWidth() > 640 && hasfilterDropdown) {
                $_filterElement.find('.filter-controls-dropdown select').val($(this).data('filter-category'));
            }
        });

        // Step 5: Set up the events for the dropdown menu
        if (hasfilterDropdown) {
            $_filterElement.find('.filter-controls-dropdown select').on('change', function() {
                if ($(window).innerWidth() <= 640) {
                    if ($(this).val() === 'all') {
                        $_filterElement
                            .find('.' + $_filterElement.data('filter-controls'))
                            .find('button.all')
                            .trigger('click');
                    } else {
                        $_filterElement
                            .find('.' + $_filterElement.data('filter-controls'))
                            .find('button[data-filter-category="' + $(this).val() + '"]')
                            .trigger('click');
                    }
                }
            });
        }

        // if not showing All, initialise the selected filter
        if ($_filterAllLast) {
            $_filterButtons.first(':is(.' + filterSelectedButtonClass + ')').trigger('click');
        }
    });
});

// Filter a list to only unique values
// https://stackoverflow.com/questions/12551635/jquery-remove-duplicates-from-an-array-of-strings
function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
        if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
}